<template>
    <div id="invite_page">
        <div class="invite_page_con">
            <div class="strong_title">
                <p>邀新即享 <span>超值会员权益</span></p>
            </div>
            <div class="desc">
                <p>即日起至12月31日，期间<span>每邀请1位新用户并激活</span>，即享受如下权益：</p>
                <p>1、邀请人&被邀请人，均获得<span>1天MJ 中文站会员</span></p>
                <p>2、邀请人&被邀请人，均获得<span>10积分</span></p>
                <p>3、被邀请人充值积分或会员，邀请人即可获得<span>充值金额的20%返现</span>（无上限累加） <span class="tixian"
                          @click="show_tixian_popup=true">去提现></span></p>
            </div>
            <div class="invite_text">
                <p>免费领取一天 Midjourney绘画中文站 VIP 会员，赶快来体验吧，https://www.midjourny.cn/home/#?from=invite&invite_id=11939816</p>
            </div>
            <div class="invite_btn flex ac">
                <div class="btn breathe"
                     @click="copy_url">
                    <span class="text">复制邀请链接</span>
                </div>
                <div class="btn"
                     @click="show_invite_code">
                    <span class="out"><span class="text">生成邀请海报</span></span>
                </div>
            </div>
            <div class="tab_list flex ac">
                <div class="tab_item"
                     :class="index==active_tab?'active':''"
                     @click="choose_tab(index)"
                     v-for="(item,index) in tab_list"
                     :key="index">{{item}}</div>
                <p class="invite_rule"><img src="./img/icon_img45.png" /><span>活动规则</span></p>
            </div>
            <div class="tab_con">
                <div class="invite_list">
                    <template v-if="active_tab==0">
                        <div class="tab_area"
                             v-if="history_list.length">
                            <div class="tab_item invite_list_first">
                                <p>用户名</p>
                                <p>用户id</p>
                                <p>奖励</p>
                                <p>邀请时间</p>
                            </div>
                            <div class="tab_scroll">
                                <div class="tab_item"
                                     v-for="(item,index) in history_list"
                                     :key="index">
                                    <p>邀请{{item.username}}</p>
                                    <p>{{item.user_id}}</p>
                                    <p>{{item.rewards}}</p>
                                    <p>{{item.time}}</p>
                                </div>
                            </div>
                        </div>
                        <Empty v-else></Empty>
                    </template>
                    <template v-else>
                        <div class="tab_area"
                             v-if="history_list.length">
                            <div class="tab_item invite_list_first">
                                <p>用户名</p>
                                <p>用户id</p>
                                <p>奖励</p>
                                <p>邀请时间</p>
                            </div>
                            <div class="tab_scroll">
                                <div class="tab_item"
                                     v-for="(item,index) in history_list"
                                     :key="index">
                                    <p>奖励{{item.username}}</p>
                                    <p>{{item.user_id}}</p>
                                    <p>{{item.rewards}}</p>
                                    <p>{{item.time}}</p>
                                </div>
                            </div>
                        </div>
                        <Empty v-else></Empty>
                    </template>
                </div>
            </div>
            <div class="tab_tips">*用户被邀请后会实时显示在该邀请列表上，并且被邀请人充值后也将立即显示在奖励列表上</div>
        </div>
        <div class="tixian_popup"
             v-if="show_tixian_popup">
            <div class="centerPanel">
                <div class="con">
                    <div class="title flex je">
                        <img src="./img/close.png"
                             class="close"
                             @click="close_tixian" />
                    </div>
                    <div class="text flex fc ac">
                        <p class="strong">可提现金额</p>
                        <p class="money">0.00</p>
                        <p class="tips">冻结金额：0.00（好友下单三天后可提现）</p>
                        <p class="tips">申请成功后，款项将自动提现到您绑定的微信号</p>
                        <span class="btn"
                              @click="ApplyWithdraw">申请提现</span>
                        <p class="tips history"
                           @click="open_history">提现记录</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="tixian_popup tixian_history_popup"
             v-if="show_history_popup">
            <div class="centerPanel">
                <div class="con">
                    <div class="title flex jb">
                        <p>提现记录</p>
                        <img src="./img/close.png"
                             class="close"
                             @click="close_history" />
                    </div>
                    <div class="tab_area"
                         v-if="history_list.length">
                        <div class="tab_item">
                            <p>用户名</p>
                            <p>用户id</p>
                            <p>奖励</p>
                            <p>邀请时间</p>
                        </div>
                        <div class="tab_scroll">
                            <div class="tab_item"
                                 v-for="(item,index) in history_list"
                                 :key="index">
                                <p>{{item.username}}</p>
                                <p>{{item.user_id}}</p>
                                <p>{{item.rewards}}</p>
                                <p>{{item.time}}</p>
                            </div>
                        </div>
                    </div>
                    <Empty v-else></Empty>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Empty from '@/components/Empty'
export default {
    components: { Empty },
    data () {
        return {
            tab_list: ['邀请列表', '奖励列表'],
            active_tab: 0,
            show_tixian_popup: false,
            show_history_popup: false,
            history_list: [
                {
                    username: 'aaa',
                    user_id: '111',
                    rewards: '100积分',
                    time: '2024-07-04 23:00:11'
                },
                {
                    username: 'aaa',
                    user_id: '111',
                    rewards: '100积分',
                    time: '2024-07-04 23:00:11'
                },
                {
                    username: 'aaa',
                    user_id: '111',
                    rewards: '100积分',
                    time: '2024-07-04 23:00:11'
                },
                {
                    username: 'aaa',
                    user_id: '111',
                    rewards: '100积分',
                    time: '2024-07-04 23:00:11'
                },
                {
                    username: 'aaa',
                    user_id: '111',
                    rewards: '100积分',
                    time: '2024-07-04 23:00:11'
                },
                {
                    username: 'aaa',
                    user_id: '111',
                    rewards: '100积分',
                    time: '2024-07-04 23:00:11'
                },
                {
                    username: 'aaa',
                    user_id: '111',
                    rewards: '100积分',
                    time: '2024-07-04 23:00:11'
                },
                {
                    username: 'aaa',
                    user_id: '111',
                    rewards: '100积分',
                    time: '2024-07-04 23:00:11'
                },
            ]
        }
    },
    methods: {
        choose_tab (index) {
            this.active_tab = index
        },
        copy_url () {
            this.copyText('baidu.com')
            this.$message({
                message: '复制成功',
                type: 'success'
            });
        },
        /**创建空input用于复制粘贴 */
        copyText (text) {
            const input = document.createElement('input');
            input.setAttribute('readonly', 'readonly');
            input.setAttribute('value', text);
            document.body.appendChild(input);
            input.setSelectionRange(0, 9999);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        },
        close_tixian () {
            this.show_tixian_popup = false
        },
        ApplyWithdraw () {
            //如果金额不足100，则提示
            this.$message.warning('您当前可提现金额不足100，快去邀请好友吧~')
        },
        open_history () {
            this.show_history_popup = true
        },
        close_history () {
            this.show_history_popup = false
        },
        show_invite_code () {
            this.$store.commit('setInviteCode', true)
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#invite_page {
    background: #131414;
    padding: 40px 0;
    height: 100%;
    overflow-y: auto;
    .invite_page_con {
        margin: 0 auto;
        max-width: 1000px;
    }
    .strong_title {
        p {
            font-size: 40px;
            font-weight: bold;
            color: #9270ff;
            line-height: 56px;
            letter-spacing: 1px;
            span {
                margin-left: 12px;
                background: linear-gradient(
                            111deg,
                            rgb(142, 255, 246) -11%,
                            rgb(248, 254, 232) 22%,
                            rgb(254, 197, 245) 66%,
                            rgb(205, 176, 255) 85%,
                            rgb(155, 145, 255)
                        )
                        text,
                    rgb(118, 77, 255); /*设置渐变的方向从左到右 颜色从ff0000到ffff00*/
                -webkit-background-clip: text; /*将设置的背景颜色限制在文字中*/
                -webkit-text-fill-color: transparent; /*给文字设置成透明*/
            }
        }
    }
    .desc {
        font-size: 18px;
        line-height: 30px;
        margin-top: 40px;
        color: #ccc;
        p {
            span {
                color: #9270ff;
                margin: 0 5px;
            }
            .tixian {
                background: linear-gradient(111deg, #f0ba77 6%, #f2d9a5 91%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
                font-weight: bold;
                cursor: pointer;
            }
        }
    }
    .invite_text {
        padding: 20px;
        margin-top: 20px;
        border-radius: 4px;
        background: #1a1a1a;
        font-size: 16px;
        color: #ccc;
        line-height: 22px;
        letter-spacing: 1px;
        word-break: break-all;
        white-space: normal;
    }
    .invite_btn {
        margin: 20px 0;
        .btn {
            box-sizing: border-box;
            -webkit-box-pack: center;
            justify-content: center;
            width: 162px;
            height: 40px;
            background: linear-gradient(
                    111deg,
                    rgb(142, 255, 246) -11%,
                    rgb(248, 254, 232) 22%,
                    rgb(254, 197, 245) 66%,
                    rgb(205, 176, 255) 85%,
                    rgb(155, 145, 255)
                ),
                rgb(118, 77, 255);
            border-radius: 20px;
            font-size: 14px;
            font-weight: 600;
            color: rgb(51, 51, 51);
            padding: 2px;
            cursor: pointer;
        }
        .out {
            box-sizing: border-box;
            width: 100%;
            height: 100%;
            display: flex;
            -webkit-box-align: center;
            align-items: center;
            -webkit-box-pack: center;
            justify-content: center;
            background-color: rgb(0, 0, 0);
            border-radius: 20px;
        }
        .text {
            color: rgb(51, 51, 51);
            line-height: 20px;
            -webkit-text-fill-color: transparent;
            background: linear-gradient(
                        111deg,
                        rgb(142, 255, 246) -11%,
                        rgb(248, 254, 232) 22%,
                        rgb(254, 197, 245) 66%,
                        rgb(205, 176, 255) 85%,
                        rgb(155, 145, 255)
                    )
                    text,
                rgb(118, 77, 255);
            -webkit-background-clip: text; /*将设置的背景颜色限制在文字中*/
            -webkit-text-fill-color: transparent; /*给文字设置成透明*/
        }
        .breathe {
            margin-right: 30px;
            animation: scale-breathe 2s infinite linear;
            .text {
                display: block;
                text-align: center;
                line-height: 38px;
                color: #000;
                width: 100%;
                background: transparent;
                -webkit-text-fill-color: #000;
            }
        }
    }
    .tab_list {
        position: relative;
        border-bottom: 2px solid #666;
        padding: 0 10px;
        .invite_rule {
            position: absolute;
            right: 10px;
            bottom: 10px;
            display: flex;
            align-items: center;
            cursor: pointer;
            font-size: 14px;
            img {
                width: 16px;
                height: 16px;
                opacity: 0.8;
                margin-right: 5px;
            }
            &:hover {
                color: #fff;
                img {
                    opacity: 1;
                }
            }
        }
        .tab_item {
            font-size: 14px;
            color: #fff;
            margin: 0 10px;
            padding: 15px 0;
            cursor: pointer;
            position: relative;
            &:after {
                content: "";
                position: absolute;
                left: 0;
                right: 0;
                bottom: -2px;
                width: 100%;
                height: 2px;
                background: transparent;
            }
            &.active {
                color: #5865f2;
                &:after {
                    background: #5865f2;
                }
            }
        }
    }
    .tab_con {
        background: #2b2d31;
        .invite_list_first {
            border-top: 0 !important;
        }
    }
    .tab_tips {
        font-size: 14px;
        color: #f1c07f;
    }
}
@keyframes scale-breathe {
    0% {
        transform: scale(1);
    }

    25% {
        transform: scale(1.05);
    }
    75% {
        transform: scale(0.95);
    }
    100% {
        transform: scale(1);
    }
}

.tixian_popup {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1501;
    bottom: 0;
    left: 0;
    transition: all 0.3s;
    background: rgba(0, 0, 0, 0.8);
    overflow: auto;
    animation: fadeInSlowAni 0.3s 1;

    .centerPanel {
        position: fixed;
        z-index: 1501;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: transform 0.2s;
        .con {
            width: 354px;
            padding: 0;
            background-color: #1e1f22;
            border: 2px solid #5865f2;
            border-radius: 5px;
            padding-bottom: 50px;
            .title {
                padding: 20px 20px 10px 20px;
                .close {
                    width: 16px;
                    height: 16px;
                    cursor: pointer;
                }
            }
            .text {
                .strong {
                    font-size: 26px;
                    color: #ccc;
                }
                .money {
                    font-size: 40px;
                    color: #ed9c2b;
                    margin-top: 10px;
                }
                .tips {
                    font-size: 13px;
                    color: #8e8e8e;
                    margin-top: 15px;
                }
                .btn {
                    cursor: pointer;
                    background-color: #5865f2;
                    color: #fff;
                    border-radius: 10rpx;
                    width: 200px;
                    line-height: 40px;
                    text-align: center;
                    border-radius: 40px;
                    margin-top: 30px;
                    font-size: 14px;
                }
                .history {
                    cursor: pointer;
                    &:hover {
                        color: #bbb;
                    }
                }
            }
        }
    }
}
.tixian_history_popup {
    .con {
        width: 500px !important;
        padding-bottom: 10px !important;
        .title {
            padding: 20px !important;
            p {
                font-size: 16px;
                color: #fff;
                font-weight: bold;
            }
        }
    }
}
.tab_area {
    padding: 0 15px;

    .tab_item {
        border-top: 1px solid #999;
        padding: 15px 0;
        display: flex;
        justify-content: space-between;
        p {
            text-align: center;
            font-size: 14px;
            color: #b7b7b7;
            &:nth-child(1) {
                width: 20%;
            }
            &:nth-child(2) {
                width: 20%;
            }
            &:nth-child(3) {
                width: 20%;
            }
            &:nth-child(4) {
                width: 40%;
            }
        }
    }
    .tab_scroll {
        max-height: 300px;
        overflow-y: auto;
    }
}
</style>